// extracted by mini-css-extract-plugin
export default {"cls1":"fV3ZgoY0ppWidnTnE4EV","cls2":"t1SuYcuwI3aZH_CwKY8q fV3ZgoY0ppWidnTnE4EV"};